var a="undefined"!=typeof FormData?FormData:null;export{a as default};
//# sourceMappingURL=FormData.js.map
